import React from 'react';

import { Project } from '@clef/shared/types';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@clef/client-library';
import { AnyUser } from '@/components/OrgAdminProjectSettingsUserTable/types';

type ConfirmTransferOwnershipDialogProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  user?: AnyUser;
  selectedProject: Project;
};

export const ConfirmTransferOwnershipDialog = ({
  open,
  onCancel,
  onConfirm,
  user,
  selectedProject,
}: ConfirmTransferOwnershipDialogProps) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Transfer Ownership</DialogTitle>
      <DialogContent>
        {t(
          'Are you sure you want to transfer ownership of project {{projectName}} to user {{userEmail}}?',
          {
            userEmail: user?.email,
            projectName: selectedProject.name,
          },
        )}
      </DialogContent>
      <DialogActions>
        <Button id="remove-user-cancel" onClick={onCancel} color="primary">
          {t('Cancel')}
        </Button>
        <Button id="remove-user-remove" onClick={onConfirm} color="primary" variant="contained">
          {t('Transfer')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
